import React, { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { AiFillCaretRight } from "react-icons/ai";
import { BsMagic } from "react-icons/bs";
import { useGetAiPromptLazyQuery } from "../../../__generated__/api";
import { LoadingIcon } from "../../loading/Loading";

const LANGUAGES = [
    "English",
    "Spanish",
    "French",
    "Russian",
    "German",
    "Italian",
    "Portuguese",
    "Dutch",
    "Chinese",
    "Japanese",
    "Korean",
    "Vietnamese",
    "Filipino",
];

export default function ArtificialIntelligenceActions({
    text,
    onChange,
}: {
    text: string;
    onChange: (data: string) => void
}): ReactElement {
    const [query, { loading: isLoading }] = useGetAiPromptLazyQuery();
    const createHandlePrompt = (prompt: string) => async () => {
        const { data } = await query({
            variables: {
                options: {
                    input: text,
                    prompt,
                },
            },
        });

        let response = data?.artificialIntelligencePrompt?.response as string;
        if (response.startsWith("\"") && response.endsWith("\"")) {
            response = response.substring(1, response.length - 1);
        }
        onChange(response);
    };
    return (
        <Dropdown>
            <Dropdown.Toggle variant="" className="menu-small p-1 btn-none text-gray-500 pe-1">
                {isLoading ? <LoadingIcon size="20px" /> : <BsMagic />}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={createHandlePrompt("Fix the spelling and grammar in the following text")}>
                    Fix spelling and grammar
                </Dropdown.Item>

                <Dropdown.Item onClick={
                    createHandlePrompt("Expand the following text if you can. Otherwise return the original text")
                }
                >
                    Expand
                </Dropdown.Item>

                <Dropdown.Item onClick={
                    createHandlePrompt("Make the following text shorter if you can. Otherwise return the original text")
                }
                >
                    Shorten
                </Dropdown.Item>

                <Dropdown drop="end">
                    <Dropdown.Toggle
                        variant=""
                        className="menu-small btn-none w-100 text-start py-1 d-flex align-items-center justify-content-between"
                    >
                        <div>Tone</div>

                        <AiFillCaretRight />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={
                            createHandlePrompt("Change the tone of the following text to sound more professional")
                        }
                        >
                            Professional
                        </Dropdown.Item>
                        <Dropdown.Item onClick={
                            createHandlePrompt("Change the tone of the following text to sound more confident")
                        }
                        >
                            Confident
                        </Dropdown.Item>
                        <Dropdown.Item onClick={
                            createHandlePrompt("Change the tone of the following text to sound more casual")
                        }
                        >
                            Casual
                        </Dropdown.Item>
                        <Dropdown.Item onClick={
                            createHandlePrompt("Change the tone of the following text to sound more friendly")
                        }
                        >
                            Friendly
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown drop="end">
                    <Dropdown.Toggle
                        variant=""
                        className="menu-small btn-none w-100 text-start py-1 d-flex align-items-center justify-content-between"
                    >
                        <div>Translate to</div>
                        <AiFillCaretRight />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {LANGUAGES.map(language => (
                            <Dropdown.Item
                                key={language}
                                onClick={
                                    createHandlePrompt(`Translate the following text to ${language}`)
                                }
                            >
                                {language}
                            </Dropdown.Item>
                        ))}

                    </Dropdown.Menu>
                </Dropdown>

            </Dropdown.Menu>
        </Dropdown>

    );
}
